import chroma from 'chroma-js';
import { resolve } from '@layouts/pages/Multichannel/components/channel-identity';
import { ELeadSource } from '../kanban-board/services/responses/lead.response';
import { CrmColors } from '../kanban-board/crm-theme';

/// A origem do lead vira a chave do Multicanal, com o mesmo ícone e cor da lista de conversas.
/// Manual e Anúncio ficam de fora: dizem de onde o lead veio, não por onde se fala com ele.
const BY_SOURCE: Partial<Record<ELeadSource, string>> = {
    [ELeadSource.WhatsApp]: 'whatsapp',
    [ELeadSource.Instagram]: 'instagram',
    [ELeadSource.Email]: 'email',
    [ELeadSource.TikTok]: 'tiktok',
    [ELeadSource.Telegram]: 'telegram',
    [ELeadSource.Sms]: 'sms',
    [ELeadSource.Website]: 'webwidget',
};

export const leadChannel = (source: number) => {
    const key = BY_SOURCE[source as ELeadSource];

    return key ? resolve(key) : null;
};

/// Cor da marca do canal quando contrasta com o fundo; a do TikTok é quase preta, então `fallback`.
export const readableChannelColor = (color: string, background: string, fallback: string) => {
    try {
        return chroma.contrast(color, background) >= 3 ? color : fallback;
    } catch {
        return fallback;
    }
};

/// Cor do ícone do canal sobre o card; sem canal conhecido, cinza: verde com balão lê como WhatsApp.
export const leadChannelColor = (source: number, cc: CrmColors): string => {
    const channel = leadChannel(source);

    if (!channel) return cc.textSecondary;

    return readableChannelColor(channel.color, cc.cardBg, cc.textPrimary);
};
